var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivoCargado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 1.33501V1.33301H13.332C13.7 1.33301 14 1.63634 14 1.99434V14.005C13.9998 14.1805 13.93 14.3487 13.8059 14.4727C13.6818 14.5967 13.5135 14.6663 13.338 14.6663H2.66202C2.57447 14.6657 2.4879 14.6479 2.40725 14.6138C2.3266 14.5797 2.25345 14.5301 2.19197 14.4678C2.1305 14.4054 2.08191 14.3316 2.04897 14.2505C2.01604 14.1694 1.9994 14.0826 2.00002 13.995L2.00002 5.33301L6.00002 1.33501ZM3.88668 5.33301H6.00002V3.21967L3.88668 5.33301ZM7.33335 2.66634V5.99967C7.33335 6.17649 7.26311 6.34605 7.13809 6.47108C7.01306 6.5961 6.84349 6.66634 6.66668 6.66634H3.33335L3.33335 13.333H12.6667V2.66634H7.33335Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivoCargado);
export default __webpack_public_path__ + "static/media/archivoCargado.219c5d05252f973ccb673efa5628edb2.svg";
export { ForwardRef as ReactComponent };